import React from 'react';

const SearchShimmer = ({ isDesktop = false }) => {
  if (isDesktop) {
    return (
      <div className="p-2 space-y-1.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="flex items-center gap-2 animate-pulse">
            <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-md " />
            <div className="flex-1 space-y-1">
              <div className="h-2.5 bg-gray-200 dark:bg-gray-700  rounded w-3/4" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {[1, 2, 3, 4, 5].map(i => (
        <div key={i} className="flex items-center gap-2 p-2 rounded-lg animate-pulse">
          <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-md " />
          <div className="flex-1 space-y-1.5">
            <div className="w-3/4 h-3 bg-gray-200 dark:bg-gray-700 rounded " />
          </div>
        </div>
      ))}
    </div>
  );
};

export default SearchShimmer;